import React from 'react';

function About() {
    return (
        <div className="container text-center">
            <h1>About</h1>
        </div>
    )
}

export default About;
